<mat-card class="slidecontent">
    <div class="headcontent">
      <div class="pophead">
        <h3>Room Detail</h3>
        <button mat-icon-button (click)="closeDetail(false)">
          <mat-icon class="close" >close</mat-icon>
        </button>
      </div>
  
    </div>
    <div class="dialog_content">
  
       
      <div class="dSection">
        <label>Name</label>
        <div class="infoDetail">
          <p>F1-1</p>
        </div>
      </div>

      <div class="dSection">
        <label>Facility</label>
        <div class="infoDetail">
          <p>Home Care</p>
        </div>
      </div>

      <div class="dSection">
        <label>Tags</label>
        <div class="infoDetail">
          <p>Home Care</p>
        </div>
      </div>


      <div class="dSection">
        <label>Equipment established</label>
        <div class="infoDetail">
          <mat-chip-list aria-label="Fish selection">
            <mat-chip-list aria-label="Fish selection">
              <mat-chip>Arthroscope</mat-chip>
              <mat-chip>Echocardiogram</mat-chip>
            </mat-chip-list>
           
          </mat-chip-list>
        </div>
      </div>  

      <div class="dSection">
        <label>Procedure</label>
        <div class="infoDetail">
          <mat-chip-list aria-label="Fish selection">
            <mat-chip>Arthroscope</mat-chip>
            <mat-chip>Echocardiogram</mat-chip>
          </mat-chip-list>
        </div>
      </div>

      <div class="dSection">
        <label>Description</label>
        <div class="infoDetail">
          <p>The operating table in the center of the room can be 
            raised, lowered, and tilted in any direction.</p>
        </div>
      </div>

    </div>
  
  
    <div class="actionBtn">
      <!-- <button mat-flat-button class="calltoaction" type="submit"  color="basic"> Clear   All </button> -->
      <button mat-flat-button class="calltoaction" type="submit" color="basic" (click)="closeDetail(false)">Close</button>
    </div>
  </mat-card>
  

  <div class="overlay" (click)="closeDetail(false)" ></div>
  
